var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-services-buttons services-buttons"},_vm._l((_vm.getServiceCategories.slice(0, 5)),function(item,index){return _c('AServiceButton',{key:index,attrs:{"item":item},on:{"onClick":_vm.showModal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }